<template>
	<div>

		<section id="page-title" class="page-title-parallax page-title-dark" style="background: url('/static/images/teatro-colombo.png') center center no-repeat; background-size: cover; box-shadow:inset 0 0 0 2000px rgba(0,0,0,0.5); padding: 75px 0;" data-bottom-top="background-position:0px 300px;" data-top-bottom="background-position:0px -300px;">

			<div class="container clearfix">
				<h1>Metodologia</h1>
				<!-- <span>Ficha de Companhia</span> -->
				<!-- <ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="#">Home</a></li>
					<li class="breadcrumb-item"><a href="#">Pages</a></li>
					<li class="breadcrumb-item active" aria-current="page">Jobs</li>
				</ol> -->
			</div>

		</section><!-- #page-title end -->

		<!-- Content
		============================================= -->
		<section id="content">

			<div class="content-wrap">

				<div class="container clearfix">

					<!-- <div class="col_three_fifth nobottommargin"> -->
					<div class="col-12">

						<p>
							Os dados relativos aos espetáculos encenados em São Paulo foram compilados em pesquisas sistemáticas e exaustivas realizadas nos jornais <i>Correio Paulistano</i> (1914-1934), <i>Folha da Manhã</i> (1922-1934) e <i>O Estado de S. Paulo</i> (1914-1934). Também foram feitas consultas pontuais em jornais paulistanos disponíveis na <a href="http://memoria.bn.br/hdb/periodico.aspx" target="_blank">Hemeroteca Digital</a> da Biblioteca Nacional do Rio de Janeiro, a exemplo de <i>O Combate</i>, <i>A Gazeta</i>, <i>Il Pasquino Coloniale</i>, entre outros. 
							<br><br>
							Não raro, uma mesma peça era anunciada na imprensa ora como revista, ora como burleta. Do mesmo modo, sua classificação no libreto podia ser diferente daquela divulgada nos meios de comunicação. Nesses casos, o critério utilizado para sua classificação foi sua adequação às convenções do gênero (estrutura das cenas, temas tratados, características do enredo, das personagens, dos números musicais etc.). A ambiguidade na definição do gênero de uma determinada peça foi registrada no item “Trajetória” de sua respectiva ficha, por considerarmos que essa é uma informação importante para o desenvolvimento de futuras pesquisas. 
							<br><br>
							Os títulos das peças, escritos no português da época, tiveram sua ortografia atualizada. As peças estrangeiras que não chegaram a ser representadas em português tiveram seus títulos mantidos no idioma original. Quando representadas tanto em língua estrangeira quanto em traduções brasileiras, seus títulos foram padronizados em português. Os artigos iniciais o(s), a(s), um(ns), uma(s) foram sempre deslocados para o final do título em português, precedidos por uma vírgula (<i>Caipirinha, A</i>; <i>Festa na Freguesia do Ó, Uma</i>). Os títulos em língua estrangeira mantiveram seus artigos na posição original (<i>La Rafale</i>; <i>The best people</i>). 
							<br><br>
							As informações sobre os elencos das companhias foram obtidas em diferentes fontes, especialmente nos jornais e revistas da Hemeroteca Digital da Biblioteca Nacional. Em função das constantes digressões das companhias teatrais pelo Brasil, foram consultados periódicos de São Paulo, Rio de Janeiro, Minas Gerais, Paraná, Santa Catarina, Rio Grande do Sul, Bahia, Pernambuco. Nem sempre a imprensa paulistana trazia informações sobre os elencos completos das companhias estrangeiras em turnê por São Paulo. Nesses casos, quando possível, recorremos a informações publicadas em periódicos de outras cidades, nas quais tais companhias haviam se apresentado imediatamente antes de se dirigir à capital paulista.

						</p>

						<!-- <div class="fancy-title title-bottom-border">
							<h3>Como Pesquisar</h3>
						</div>

						<p>
							A
						</p> -->
						

					</div>

					<!-- <div class="col_two_fifth nobottommargin col_last">

						<div id="job-apply" class="heading-block highlight-me">
							<h2>Fotos</h2>
							<span>And we'll get back to you within 48 hours.</span>
						</div>

						<div>
							<img src="https://storage.googleapis.com/templates-html/companhia-arruda.png">
						</div>

					</div> -->

				</div>

			</div>

		</section>

	</div>
</template>



<script>

export default {
  name: 'Methodology',
}

</script>


<style scoped>
.heading-block:after {
	margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Methodology.vue